'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppController = function AppController($scope, $rootScope, User, AuthenticationService, FunctionService, $cookieStore, $location, V2Service, $timeout, $state) {
  _classCallCheck(this, AppController);

  var initialLocation = window.location.href;
  this.appFunctions = [];
  this.appFunctionSettings = {};
  this.appMenuFunctions = [];
  this.loginRoute = 'login';
  this.logoutRoute = 'logout';

  $rootScope.globals = $cookieStore.get('globals') || {};
  $cookieStore.remove('redirectURL');
  // console.log('$rootScope.globals: ' + JSON.stringify($rootScope.globals));

  var params = $location.search();

  if (params.token) {
    // console.log('Got v2 token...');
    $rootScope.globals = {
      currentUser: {
        codingOperationsTeam: false,
        email: params.email,
        name: params.firstname + ' ' + params.lastname,
        speciality: params.speciality,
        role: params.role,
        worklist: params.worklist,
        id: params.userId,
        token: params.token,
        roleId: params.roleId,
        redirectRoute: params.redirectRoute,
        activeDirectoryToken: '',
        initialLogin: false,
        campus: params.campus
      }
    };

    AuthenticationService.SetCredentials(false, params.email, params.firstname + ' ' + params.lastname, params.speciality, params.role, params.worklist, params.userId, params.token, Number(params.roleId), '', undefined, undefined, params.campus);

    $cookieStore.put('globals', $rootScope.globals);
    User.setUser(false, params.firstname + ' ' + params.lastname, params.email, params.speciality, params.role, params.worklist, params.userId, params.token, Number(params.roleId), undefined, false, params.campus);
    this.user = User.getUser();

    this.userRoleId = 0;
    if ($rootScope.globals.currentUser && $rootScope.globals.currentUser.roleId) {
      if (!$scope.vm.user.name) {
        $scope.vm.user.name = $rootScope.globals.currentUser.firstname + ' ' + $rootScope.globals.currentUser.lastname;
      }
      $scope.vm.userRoleId = $rootScope.globals.currentUser.roleId;
    }

    if (initialLocation.indexOf('v2') > -1) {
      V2Service.redirectToV2($scope.vm.userRoleId);
    }

    // If cookie has roleId stored then fetch function list
    if ($rootScope.globals.currentUser && $rootScope.globals.currentUser.roleId) {
      FunctionService.getFunctions($rootScope.globals.currentUser.roleId);
    }

    // Subscribe to functions fetched event then populate side menu lists
    FunctionService.subscribe($scope, function (event, data) {
      if (event.name === 'functions-fetched-event') {
        $scope.vm.appFunctionSettings = data.functionSettings;
        $scope.vm.appFunctions = data.functions;
        $scope.vm.appMenuFunctions = data.functions.filter(function (x) {
          return x.functionType === 'MEN';
        });
      }
    });
  } else if ($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.token) {
    AuthenticationService.SetCredentials(false, $rootScope.globals.currentUser.email, $rootScope.globals.currentUser.name, $rootScope.globals.speciality, $rootScope.globals.currentUser.role, $rootScope.globals.worklist, $rootScope.globals.currentUser.id, $rootScope.globals.currentUser.token, Number($rootScope.globals.currentUser.roleId), '', undefined, undefined, $rootScope.globals.campus);

    User.setUser(false, $rootScope.globals.currentUser.name, $rootScope.globals.currentUser.email, '', $rootScope.globals.currentUser.role, [], $rootScope.globals.currentUser.id, $rootScope.globals.currentUser.token, Number($rootScope.globals.currentUser.roleId), undefined, false, '');
    this.user = User.getUser();

    // If cookie has roleId stored then fetch function list
    if ($rootScope.globals.currentUser && $rootScope.globals.currentUser.roleId) {
      FunctionService.getFunctions($rootScope.globals.currentUser.roleId);
    }

    // Subscribe to functions fetched event then populate side menu lists
    FunctionService.subscribe($scope, function (event, data) {
      if (event.name === 'functions-fetched-event') {
        $scope.vm.appFunctionSettings = data.functionSettings;
        $scope.vm.appFunctions = data.functions;
        $scope.vm.appMenuFunctions = data.functions.filter(function (x) {
          return x.functionType === 'MEN';
        });
      }
    });
  }
  if ($scope.vm.user) {
    if (params.redirectRoute === undefined) {
      var path = window.location.pathname.substring(1).replace('/', '.');
      // console.log('Path: ' + path);
      if (path !== '' && path.substring(0, 2) !== 'v2') {
        if (path !== 'home') {
          $state.go(path, {}, {});
        } else {
          $state.go('admin', {}, {});
        }
      } else if (path === '') {
        // console.log('Going to login page now!');
        $state.go('login', {}, {});
      } else {
        window.location = window.location.origin + '/v2/index.html';
      }
    } else if (params.redirectRoute === 'admin' || params.redirectRoute === '') {
      $state.go('admin', {}, {});
    } else {
      $state.go(params.redirectRoute.replace('/', '.').replace('-', ''), {}, {});
    }
  } else {
    // console.log('Got no token, redirect to login page...');
    $state.go('login', {}, {});
  }

  $('.mdl-layout__drawer a').click(function () {
    closeMenu();
  });

  function closeMenu() {
    var d = document.querySelector('.mdl-layout');
    d.MaterialLayout.toggleDrawer();
  }

  $scope.getFunctionSetting = function (funcName, setting) {
    return $scope.vm.appFunctionSettings && $scope.vm.appFunctionSettings[funcName] ? $scope.vm.appFunctionSettings[funcName][setting] : false;
  };

  $scope.isLoginPage = function () {
    return $location.path().indexOf('login') > -1;
  };

  $scope.isLogoutPage = function () {
    return $location.path().indexOf('logout') > -1;
  };

  $scope.navItemClick = function (route, toggleMenu) {

    $rootScope.globals = $cookieStore.get('globals');
    var roleId = $rootScope.globals.currentUser.roleId ? $rootScope.globals.currentUser.roleId : $scope.vm.userRoleId;

    // If on login page assume logged out so clear function settings
    if (route.indexOf($scope.vm.loginRoute) > -1 || route.indexOf($scope.vm.logoutRoute) > -1) {
      $scope.vm.appFunctionSettings = {};
      $scope.vm.appFunctions = [];
    }

    // Close nav menu when left hand menu item clicked
    if (toggleMenu) {
      var d = document.querySelector('.mdl-layout');
      d.MaterialLayout.toggleDrawer();
    }

    if (route.indexOf('v2') > -1) {
      $rootScope.stopTokenRefresh = true;
      var cfDomain = '.codefocus.com.au';
      var cfDomainIndex = window.location.hostname.indexOf(cfDomain) || window.location.hostname.indexOf('10.0.1.1');

      $rootScope.globals.currentUser.redirectRoute = route.replace('' + V2CONTEXT + '/', '');

      AuthenticationService.SetCredentials($rootScope.globals.currentUser.codingOperationsTeam, $scope.vm.user.email, $scope.vm.user.name, $scope.vm.user.specialty, $scope.vm.user.role, $scope.vm.user.worklist, $scope.vm.user.id, $scope.vm.user.token, roleId, $rootScope.globals.currentUser.redirectRoute, $rootScope.globals.currentUser.activeDirectoryToken, $rootScope.globals.currentUser.initialLogin, $scope.vm.user.campus);

      if (window.location.hostname.indexOf('localhost') > -1) {
        if (roleId) {
          window.location = 'http://localhost:4200/' + V2CONTEXT + '?token=' + $rootScope.globals.currentUser.token + '&roleId=' + roleId + '&redirectRoute=' + $rootScope.globals.currentUser.redirectRoute;
        }
      } else if (cfDomainIndex > -1) {
        V2Service.redirectToV2(roleId);
      }
    }
  };
};

exports.default = AppController;


// WEBPACK FOOTER //
// ./client/app/app.controller.js